import router from "../router";
import { bus } from "../main";

export default {
  namespaced: true,
  state: {
    isOverridingBackground: false,
    showAssetTag: {},
    showAssetSource: [],
    showAssetvirtualTourUrl: "",
    meta: {},

    showIframeUrl: "",
  },

  getters: {
    isShowingAssetViewer(state) {
      if (typeof state.showAssetSource === "string") return true;
      if (Array.isArray(state.showAssetSource) && state.showAssetSource.length) return true;
      return false;
    },
  },

  actions: {
    TRIGGER_CHANGE_BACKGROUND({ commit, state, rootState }, { payload }) {
      state.isOverridingBackground = !state.isOverridingBackground;
      const getLocalizedPayload = () => {
        if (!payload) return [];
        if (Array.isArray(payload)) return payload;
        return payload[rootState.language.code] || payload.en || [];
      };

      const localizedPayload = getLocalizedPayload();

      if (state.isOverridingBackground) {
        commit("SET_ACTIVE_BACKGROUND_OVERRIDE", localizedPayload, { root: true });
      } else {
        commit("SET_ACTIVE_BACKGROUND_OVERRIDE", "", { root: true });
      }

      setTimeout(() => {
        bus.$emit("startAnimations");
      }, 500);
    },

    TRIGGER_NAV_ROUTER({ rootState }, { payload }) {
      const getLocalizedPayload = () => {
        if (!payload) return [];
        if (Array.isArray(payload)) return payload;
        return payload[rootState.language.code] || payload.en || [];
      };

      const localizedPayload = getLocalizedPayload();
      router.push(localizedPayload[0]);
    },

    TRIGGER_CUSTOM_NAV_ROUTER({ rootState }, { payload }) {
      const getLocalizedPayload = () => {
        if (!payload) return [];
        if (Array.isArray(payload)) return payload;
        return payload[rootState.language.code] || payload.en || [];
      };

      const localizedPayload = getLocalizedPayload();
      router.push(localizedPayload[0]);
    },

    TRIGGER_SHOW_ASSET({ dispatch, commit, rootState, rootGetters }, { payload, tag, virtualTourUrl, meta }) {
      const getLocalizedPayload = () => {
        if (!payload) return [];
        if (Array.isArray(payload)) return payload;
        return payload[rootState.language.code] || payload.en || [];
      };

      const localizedPayload = getLocalizedPayload();

      if (Array.isArray(localizedPayload) && localizedPayload.length) {
        dispatch("triggerVideo", process.env.VUE_APP_PROJECT + "_" + localizedPayload[0].substring(localizedPayload[0].indexOf("/") + 1).replace("png", "jpg"), { root: true });
        dispatch("announceSwarmContext", localizedPayload[0].substring(localizedPayload[0].indexOf("/") + 1).replace("png", "jpg"), { root: true });
      } else {
        dispatch("triggerVideo", process.env.VUE_APP_PROJECT + "_" + rootGetters.activeBottomBarPageLabel + ".mp4", { root: true });
        dispatch("announceSwarmContext", rootGetters.activeBottomBarPageLabel, { root: true });
      }
      commit("SET_SHOW_ASSET_PAYLOAD", { payload: localizedPayload, tag, virtualTourUrl, meta });
    },
  },

  mutations: {
    SET_SHOW_ASSET_PAYLOAD(state, { payload, tag, virtualTourUrl, meta }) {
      state.showAssetTag = tag;
      state.showAssetSource = payload;
      state.showAssetvirtualTourUrl = virtualTourUrl;
      state.meta = meta;
    },

    SET_IFRAME_URL(state, url) {
      state.showIframeUrl = url;
    },
  },
};
